import { render } from "./WorkflowfolgeclientfunktionenModalCreate.pug?vue&type=template&id=3183e4d8&lang=pug"
import script from "./WorkflowfolgeclientfunktionenModalCreate.js?vue&type=script&lang=js"
export * from "./WorkflowfolgeclientfunktionenModalCreate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__